import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { debtRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.SUPER_ADMIN];

const debtRouteMetadata: IRouteMetadataObj<typeof debtRoutesObj> = {
  list: {
    title: "financialManagement.index.title",
    description: "empty",
    lazy: () => import("@/pages/financialManagement/incomeDebt/table/page"),
    mode: "index",
    type: "main",
    icon: "ReceiptLine",
    breadcrumbs: [],
    permission,
  },
};

export const debtRoutes = createRoute<typeof debtRoutesObj>(
  debtRoutesObj,
  debtRouteMetadata,
);
